import React from 'react';
import { Route, Switch, Redirect } from 'react-router';
import { Provider } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';

// Import components as routes.
import Campaign from '../containers/campaign/Campaign';
import NotFound from './pages/NotFound/NotFound';
import Login from './pages/Login';
import CampaignList from '../containers/campaign/CampaignList';
import configureStore from '../store/configure';
import api from '../services/api';
import LineItem from '../containers/campaign/lineitem/LineItem';
import Audiences from '../containers/Audiences';
import ForecastList from '../containers/forecast/ForecastList';
import Forecast from '../containers/forecast/Forecast';
import RequireAuthentication from '../containers/RequireAuthentication';
import Settings from '../containers/Settings';

const { store, history } = configureStore({}, { api: api.create() });

const App = () => (
  <Provider store={store}>
    <ConnectedRouter history={history}>
      <Switch>
        <Route exact path="/" render={() => <Redirect to="/campaigns" />} />{' '}
        <Route exact path="/login" component={Login} />
        <Route exact path="/settings" component={RequireAuthentication(Settings)} />
        <Route exact path="/campaigns" component={RequireAuthentication(CampaignList)} />
        <Route exact path="/campaigns/:campaignId" component={RequireAuthentication(Campaign)} />
        <Route
          exact
          path="/forecasts/:forecastId/revision/:revisionId"
          component={RequireAuthentication(Forecast)}
        />
        <Route
          exact
          path="/campaigns/:campaignId/line/:lineItemId"
          component={RequireAuthentication(LineItem)}
        />
        <Route exact path="/audiences" component={RequireAuthentication(Audiences)} />
        <Route exact path="/forecasts" component={RequireAuthentication(ForecastList)} />
        <Route exact path="*" component={NotFound} />
      </Switch>
    </ConnectedRouter>
  </Provider>
);

export default App;
